import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';

import cs from 'classnames';

import useDebounce from 'lib/hooks/useDebounce';
import { useVendors } from 'lib/hooks/queries/vendor/useGetVendors';

import Input from 'components/shared/Input/Input';
import FilestackImage from 'components/shared/Image/FilestackImage/FilestackImage';
import S3Uploader from 'components/admin/pages/GeneralUploader/components/FileS3Multipart';
import useFileUploader from 'components/admin/pages/GeneralUploader/components/lib/useFileUploader';
import {
  CHUNK_SIZE,
  FILE_UPLOAD_STATUS
} from 'components/admin/pages/GeneralUploader/components/lib/constants';

const SoftwareExport = () => {
  const { practice } = useOutletContext();
  const [files, setFiles] = useState([]);
  const [selectedEHR, setSelectedEHR] = useState(null);
  const [setUploadProgressList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearch = useDebounce(searchTerm);
  const { uploadFile } = useFileUploader();

  const { data } = useVendors({
    params: { withCount: true, page: 1, limit: 25, filters: { searchTerm: debouncedSearch } }
  });

  if (!data?.vendors) {
    return null;
  }

  const handleUploadClick = async (files) => {
    const progressInit = files.map((file) => ({
      filename: file.name,
      progress: 0,
      total: Math.ceil(file.size / CHUNK_SIZE),
      size: file.size,
      status: FILE_UPLOAD_STATUS.INITIATED
    }));

    setUploadProgressList(progressInit);
    await uploadFile(files, practice, selectedEHR, setUploadProgressList);
  };

  return (
    <div className="flex w-full justify-center">
      <div className="w-full pt-8 text-left">
        <p className="text-lg font-500 text-primary-900">Software export</p>
        <p className="!mb-8 text-sm text-neutral-700">
          Select the software from which you've exported your data and upload the corresponding file
          to continue the import process
        </p>
        <div className="flex w-full gap-10">
          <div className="w-full">
            <div className="w-full">
              <Input
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                }}
                placeholder="Search"
                icon="search-linear"
                className="mb-5"
              />
            </div>
            <ul className="flex w-full flex-col gap-4">
              {data?.vendors
                ? data?.vendors?.map((v) => (
                    <div
                      key={v.id}
                      onClick={() => setSelectedEHR(v)}
                      className={cs(
                        'flex max-h-10 w-full cursor-pointer items-center gap-2 rounded-lg border border-solid border-neutral-100 bg-white px-4 py-3',
                        selectedEHR?.id === v.id && 'border-primary-300 bg-primary-50'
                      )}>
                      {v?.logo && v?.logo !== '' && (
                        <div>
                          <FilestackImage
                            className="w-max"
                            imgClassName="rounded-md h-full max-h-6 w-auto"
                            src={v.logo}
                            alt={`${v.name ?? 'Vendor'} logo`}
                          />
                        </div>
                      )}
                      <div>{v.name}</div>
                    </div>
                  ))
                : searchTerm.trim() === ''
                  ? 'No software available'
                  : 'No software found'}
            </ul>
          </div>
          <div className="w-full">
            <S3Uploader
              files={files}
              setFiles={setFiles}
              maxFiles={10}
              onUpload={handleUploadClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoftwareExport;
